import type { RouteLocationNormalizedLoaded } from 'vue-router'
import { mainService as mainServiceConfig } from './main'
import { services, type ServiceConfig } from './services'

export interface RegisteredSpaceTool {
	id: string
	serviceName: string
	title: string
	icon: string
	description: string
	order: number
	buildPath: (spaceId: string | number) => string
	isActive: (route: RouteLocationNormalizedLoaded, spaceId: string | number | null | undefined) => boolean
}

function createTool(serviceName: string, config: ServiceConfig): RegisteredSpaceTool | null
{
	if (!config.spaceTool)
		return null

	const target = config.spaceTool.target || 's'
	const entryAction = config.spaceTool.entryAction
	const pathPrefix = `/${serviceName}/${target}/`

	return {
		id: serviceName,
		serviceName,
		title: config.spaceTool.title,
		icon: config.spaceTool.icon,
		description: config.spaceTool.description,
		order: config.spaceTool.order ?? 100,
		buildPath: (spaceId) => `/${spaceId}${pathPrefix}${entryAction}`,
		isActive: (route, spaceId) => {
			if (!spaceId)
				return false

			return route.path.startsWith(`/${spaceId}${pathPrefix}`)
		}
	}
}

export function getRegisteredSpaceTools(): RegisteredSpaceTool[]
{
	const toolEntries: Array<[string, ServiceConfig]> = [
		['main', mainServiceConfig],
		...Object.entries(services).filter(([serviceName]) => serviceName !== 'main')
	]

	return toolEntries
		.map(([serviceName, config]) => createTool(serviceName, config))
		.filter((tool): tool is RegisteredSpaceTool => !!tool)
		.sort((a, b) => a.order - b.order || a.title.localeCompare(b.title))
}
